const Menu = ({ width = 20, height = 20, color = 'currentColor', ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      color={color}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66669 4.99984C1.66669 4.5396 2.03978 4.1665 2.50002 4.1665H17.5C17.9603 4.1665 18.3334 4.5396 18.3334 4.99984C18.3334 5.46007 17.9603 5.83317 17.5 5.83317H2.50002C2.03978 5.83317 1.66669 5.46007 1.66669 4.99984Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66669 9.99984C1.66669 9.5396 2.03978 9.1665 2.50002 9.1665H17.5C17.9603 9.1665 18.3334 9.5396 18.3334 9.99984C18.3334 10.4601 17.9603 10.8332 17.5 10.8332H2.50002C2.03978 10.8332 1.66669 10.4601 1.66669 9.99984Z"
        fill={color}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.66669 14.9998C1.66669 14.5396 2.03978 14.1665 2.50002 14.1665H17.5C17.9603 14.1665 18.3334 14.5396 18.3334 14.9998C18.3334 15.4601 17.9603 15.8332 17.5 15.8332H2.50002C2.03978 15.8332 1.66669 15.4601 1.66669 14.9998Z"
        fill={color}
      />
    </svg>
  )
}

export default Menu
